import { render, staticRenderFns } from "./app.vue?vue&type=template&id=386b8f90&vue3"
import script from "./app.vue?vue&type=script&lang=js&vue3"
export * from "./app.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports